import { IPublicClientApplication } from '@azure/msal-browser';
import { ProfilesSdk } from './profiles/profiles.sdk';
import axios from 'axios';

import { apiEndpoint, baseUrl } from './config';

// Build info from /version endpoint
export interface BuildInfo {
    buildNumber: string;
    buildTimestamp: string;
    gitHash?: string;
    elasticsearch?: {
        indexName: string | null;
        ttlSeconds: number;
        expiresAt?: string;
    };
}

export class ZaplifySdk {
    profiles: ProfilesSdk;

    constructor(endpoint?: string, authProvider?: IPublicClientApplication) {
        if (endpoint === undefined) endpoint = apiEndpoint;
        this.profiles = new ProfilesSdk(endpoint || '', authProvider);
    }

    // Fetch build version info from /version endpoint
    async getVersion(): Promise<BuildInfo | null> {
        try {
            const response = await axios.get<BuildInfo>(`${baseUrl}/version`);
            return response.data;
        } catch {
            return null;
        }
    }
}

export const getZaplifySdk = (apiEndpoint?: string, authProvider?: IPublicClientApplication): ZaplifySdk => {
    return new ZaplifySdk(apiEndpoint, authProvider);
};
